export default function close ($closeElems) {
	$closeElems.each((i, root) => {
		let $root = $(root);

		$root.on('click.close', '[data-close="trigger"]', (e) => {
			let $thisRoot = $(e.delegateTarget);

			$thisRoot.fadeOut(300);
		});
	});
}



// WEBPACK FOOTER //
// ./_HTML/src/js/_modules/close.js